module.exports = __webpack_public_path__ + "img/home_sxgl.24333770.png";